import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'booleanSymbol',
})
export class BooleanSymbolPipe implements PipeTransform {
	transform(value: boolean, args?: { invert?: boolean }): string {
		return value !== !!args?.invert ? '✓' : '✗';
	}
}
